import { inject, injectable } from "@launchtray/tsyringe-async";
import { PieceColor } from "../../../enums/PieceColor";
import { TriangleRotationStatus } from "../../../enums/TriangleRotationStatus";
import { ISquareModel } from "../../../models/square/ISquareModel";
import { ITriangleModel } from "../../../models/triangle/ITriangleModel";
import { ITriangleModelFactory } from "../../triangles/ITriangleModelFactory";
import { ISquareModelFactory } from "../ISquareModelFactory";
import { InjectableFactories } from "../../../../../composition/InjectableFactories";
import { InjectableInterfaces } from "../../../../../composition/InjectableInterfaces";
import { InjectableModelFactories } from "../../../../../composition/InjectableModelFactories";
import { SquareModel } from "../../../models/square/impl/SquareModel";

@injectable()
export class FullSquareModelFactory implements ISquareModelFactory {
    public constructor(
        @inject(InjectableModelFactories.ITriangleModelFactory) private readonly triangleModelFactory: ITriangleModelFactory
    ) { }

    public createSquare(rotationStatus: TriangleRotationStatus, color: PieceColor): ISquareModel {
        const triangles = new Array<ITriangleModel>();
        switch (rotationStatus) {
            case TriangleRotationStatus.BOTTOM_LEFT:
                triangles.push(this.triangleModelFactory.createTriangle(TriangleRotationStatus.BOTTOM_LEFT, color));
                triangles.push(this.triangleModelFactory.createTriangle(TriangleRotationStatus.TOP_RIGHT, color));
                break;
            case TriangleRotationStatus.TOP_RIGHT:
                triangles.push(this.triangleModelFactory.createTriangle(TriangleRotationStatus.BOTTOM_LEFT, color));
                triangles.push(this.triangleModelFactory.createTriangle(TriangleRotationStatus.TOP_RIGHT, color));
                break;
            case TriangleRotationStatus.TOP_LEFT:
                triangles.push(this.triangleModelFactory.createTriangle(TriangleRotationStatus.TOP_LEFT, color));
                triangles.push(this.triangleModelFactory.createTriangle(TriangleRotationStatus.BOTTOM_RIGHT, color));
                break;
            case TriangleRotationStatus.BOTTOM_RIGHT:
                triangles.push(this.triangleModelFactory.createTriangle(TriangleRotationStatus.TOP_LEFT, color));
                triangles.push(this.triangleModelFactory.createTriangle(TriangleRotationStatus.BOTTOM_RIGHT, color));
                break;
        }
        return new SquareModel(triangles);
    }
}